import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const InquiryCard = ({ inquiry, onRespond, onViewProfile }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'new': return 'text-primary bg-blue-50';
      case 'responded': return 'text-success bg-green-50';
      case 'viewed': return 'text-warning bg-yellow-50';
      case 'closed': return 'text-text-secondary bg-gray-50';
      default: return 'text-text-secondary bg-muted';
    }
  };

  const getVerificationIcon = (isVerified) => {
    return isVerified ? (
      <Icon name="CheckCircle" size={16} className="text-success" />
    ) : (
      <Icon name="AlertCircle" size={16} className="text-warning" />
    );
  };

  const formatTimeAgo = (date) => {
    const now = new Date();
    const inquiryDate = new Date(date);
    const diffInHours = Math.floor((now - inquiryDate) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    return `${Math.floor(diffInHours / 24)}d ago`;
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-4 shadow-property-card hover:shadow-modal transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="relative">
            <Image
              src={inquiry.userAvatar}
              alt={inquiry.userName}
              className="w-12 h-12 rounded-full object-cover"
            />
            <div className="absolute -bottom-1 -right-1">
              {getVerificationIcon(inquiry.isVerified)}
            </div>
          </div>
          <div>
            <div className="flex items-center space-x-2">
              <h4 className="font-semibold text-text-primary">{inquiry.userName}</h4>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(inquiry.status)}`}>
                {inquiry.status}
              </span>
            </div>
            <div className="text-sm text-text-secondary">{inquiry.userEmail}</div>
          </div>
        </div>
        <div className="text-xs text-text-secondary">
          {formatTimeAgo(inquiry.createdAt)}
        </div>
      </div>

      <div className="mb-3">
        <div className="text-sm font-medium text-text-primary mb-1">
          Interested in: {inquiry.propertyTitle}
        </div>
        <div className="text-sm text-text-secondary line-clamp-2">
          {inquiry.message}
        </div>
      </div>

      <div className="flex items-center justify-between text-xs text-text-secondary mb-3">
        <div className="flex items-center space-x-4">
          <span className="flex items-center">
            <Icon name="Phone" size={12} className="mr-1" />
            {inquiry.userPhone}
          </span>
          <span className="flex items-center">
            <Icon name="MapPin" size={12} className="mr-1" />
            {inquiry.userLocation}
          </span>
        </div>
        <div className="flex items-center">
          <Icon name="Star" size={12} className="mr-1 text-warning" />
          <span>Lead Score: {inquiry.leadScore}/10</span>
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="User"
          iconPosition="left"
          onClick={() => onViewProfile(inquiry.id)}
          className="flex-1"
        >
          View Profile
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="MessageCircle"
          iconPosition="left"
          onClick={() => onRespond(inquiry.id)}
          className="flex-1"
        >
          Respond
        </Button>
      </div>
    </div>
  );
};

export default InquiryCard;